<template>
    <div>
    	<el-dialog width="500px" :visible.sync="shareVisible" :before-close="cancel" custom-class="game-share-dialog" :close-on-click-modal="false" background-color="#f2f3f6" top="204px" v-if="shareVisible">
    		<div slot="title" class="title-dialog">动态分享专用设置</div>
    		<div class="share-content">
                <div class="item">
                    <label class="label">动态分享专用图：</label>
                	<div class="content" v-show="urlBackup">
                        <avatar @image-ok="changeLogo" ref="avatar" :url="urlBackup" :size="90" :aspectRatio="1" :changable="true"></avatar>
                    </div>
                    <div class="content no-image" v-show="!urlBackup">暂未设置专用图</div>
                    <span class="btn" @click="changeImg">更换</span>
                </div>
                <div class="item">
                	<label class="label">动态分享图介绍：</label>
                	<div class="content">
                        <span v-show="!editIntroType" class="info textarea-info">{{introBackup || '暂无介绍'}}</span>
                        <div class="edit-textarea" v-show="showIntroInput">
                            <textarea type="text" placeholder="暂无介绍" class="input bigInput" ref="intro" @blur="changeIntro" v-model="introBackup"></textarea>
                        </div>
                        <p class="error-info" v-if="editIntroType">{{errorInfo}}</p>
                    </div>
                    <span class="btn" @click="editShareContent">编辑</span>
    			</div>
    		</div>
    		<div slot="footer" class="footer">
                <btn :type="1" info="取消" @click="cancel"></btn>
                <btn :type="0" info="保存" @click="checkContent"></btn>
            </div>   
    	</el-dialog>
        <confirm :visible.sync="ConfirmVisible">
            <h4 class="title-dia" slot="title">{{dialogInfo['saveShare'].title}}</h4>
            <p>{{dialogInfo['saveShare'].content}}</p>
            <span slot="op-btns" class="op-btns">
                <btn v-for="(item, index) in dialogInfo['saveShare'].btns" :key="index" :type="item.type" :info="item.label" @click="item.clickEvent"></btn>
            </span>
        </confirm>
    </div>
</template>
<script>
import dao from '@/lib/dao.js';

import Btn from '@/components/Button.vue';
import Avatar from '@/components/Avatar.vue';
import Confirm from '@/components/Confirm.vue';

export default {
	components: {
		Btn,
        Avatar,
        Confirm
	},
	props:{
	    shareVisible: {
	        type: Boolean,
	        default: false
	    },
	    info: {
            type: Object,
            default() {
                return {
                	logo: '',
                	dynamic: {
                        shareImage: null,
                        shareContent: null
                    }
                };
            }
        }
	},
	data() {
        const self = this;
		return {
			editIntro: false,
			introBackup: '',
			showIntroInput: false,
            errorInfo: '',
            editIntroType: false,
            urlBackup: '',
            dialogInfo: {
                'saveShare': {
                    title: '确认关闭动态分享设置吗?',
                    content: '',
                    btns: [
                        {
                            label: '取消',
                            type: 1,
                            clickEvent() {
                                self.continue();
                            }
                        },
                        {
                            label: '确认',
                            type: 0,
                            clickEvent() {
                                self.closeAll();
                            }
                        }
                    ]
                }
            },
            ConfirmVisible: false,
            modifyInfo: {}
		}
	},
	methods: {
		cancel() {
            if (JSON.stringify(this.modifyInfo) == "{}") {
                // 无修改关闭设置弹框
                this.$emit('closeShareSeeting');
            } else {
                // 存在修改时，出提示弹框
                this.ConfirmVisible = true;
                // this.$emit('closeShareSeeting');
            }
		},
		changeImg() {
            this.$refs.avatar.$el.children[1].click();
		},
        changeLogo(url) {
            this.urlBackup = url;
            url ? this.$set(this.modifyInfo, 'url', url) : '';
        },
        changeIntro() {
            this.introBackup = this.introBackup.trim();
            if (this.info.dynamic.shareContent) {
                if (this.introBackup === this.info.dynamic.shareContent) {
                    // 点了编辑按钮，无修改
                    this.showIntroInput = false;
                    this.editIntroType = false;
                    return
                } else {
                    if (this.introBackup) {
                        if (this.introBackup.length > 60) {
                           this.$message.error('文案最多输入64个字符');  
                        } else {
                            this.$set(this.modifyInfo, 'intro', this.introBackup);
                            this.showIntroInput = false;
                            this.editIntroType = false;
                        }
                    } else {
                        this.$set(this.modifyInfo, 'intro', this.introBackup);
                        this.showIntroInput = false;
                        this.editIntroType = false;
                    }
                }
            } else {
                if (!this.introBackup) {
                    this.modifyInfo.intro ? this.$delete(this.modifyInfo, 'intro') : '';
                } else {
                    this.$set(this.modifyInfo, 'intro', this.introBackup);
                }
                this.showIntroInput = false;
                this.editIntroType = false;
            }
        },
        editShareContent() {
            this.editIntroType = true;
            this.showIntroInput = true;
            this.$nextTick(_ => {
                this.$refs.intro.focus();
            });
        },
        closeAll() {
            this.ConfirmVisible = false;
            this.$emit('closeShareSeeting');
        },
        continue() {
            this.ConfirmVisible = false;
        },
        checkContent() {
            if (!!this.introBackup !== !!this.urlBackup) {
                // 一个为空
                this.introBackup.trim().length ? this.$message.error('动态分享专用图不能为空') : this.$message.error('动态分享文案不能为空');
                return
            } else if (!!this.introBackup || !!this.urlBackup) {
                // 同时存在且不为空
                this.submitModify();
            } else {
                // 同时为空
                this.$emit('closeShareSeeting');
            }
        },
        submitModify() {
            if (this.introBackup.trim().length !== 0 && this.urlBackup !== '' && this.introBackup.trim().length <= 60) {
                dao.shop.updateDynamicInfo({
                    appId: this.info.appId,
                    shareImage: this.urlBackup,
                    shareContent: this.introBackup.trim()
                }).then(_ => {
                    this.info.dynamic.shareContent = this.introBackup.trim();
                    this.info.dynamic.shareImage = this.urlBackup;
                    this.showIntroInput = false;
                    this.editIntroType = false;
                    this.errorInfo = '';
                    this.$emit('closeShareSeeting');
                }).catch(msg => {
                    this.showIntroInput = false;
                    this.editIntroType = false;
                    this.introBackup = this.info.dynamic.shareContent || '';
                    this.urlBackup = this.info.dynamic.shareImage || '';
                    this.modifyInfo = {};
                    this.$message.error(msg);
                    this.$emit('closeShareSeeting');
                });
            } else {
                return
            }
        }
	},
    mounted() {
        this.introBackup = this.info.dynamic.shareContent || '';
        this.urlBackup = this.info.dynamic.shareImage || '';
    }
}
</script>
<style lang="less" scoped>
.game-share-dialog {
 	color: #5C667E;
    .title-dialog {
    	color: #5C667E;
        font-size: 18px;
    }
    .share-content {
        font-size: 12px;
        .item {
            box-sizing: border-box;
            height: 100px;
            display: flex;
            align-items: center;
            margin-bottom: 15px;
            .label {
                margin-right: 10px;
                width: 120px;
            }
            .content {
                display: inline-block;
                position: relative;
                color: #5C667E;
                &.no-image {
                    width: 200px;
                    margin-right: 50px;
                }
                .info {
                    cursor: pointer;
                    height: 22px;
                    display: inline-block;
                    min-width: 153px;
                    line-height: 18px;
                    word-break: break-all;
                    color: #5C667E;

                    &.textarea-info {
                        width: 200px;
                        margin-right: 50px;
                    }
                }
                .edit-textarea {
                    position: relative;
                    height: 70px;
                }
                .error-info {
                    color: #FF7B58;
                    font-size: 12px;
                    line-height: 14px;
                    position: absolute;
                    bottom: -35px;
                }
                .input {
                    border: 1px solid #E0E5EC;
                    height: 28px;
                    border-radius: 17px;
                    box-sizing: border-box;
                    padding: 0 30px 0 10px;
                    color: #5C667E;
                    font-size: 14px;
                    width: 230px;
                    outline: none;

                    &.bigInput {
                        padding: 5px;
                        width: 200px;
                        margin-right: 50px;
                        height: 115px;
                        border-radius: 2px;
                    }
                } 
                .input::-moz-placeholder {
                    color: #9AA7C1;
                    font-size: 12px;
                }
                .input::-webkit-input-placeholder {
                    color: #9AA7C1;
                    font-size: 12px;
                }
                .input::-ms-input-placeholder {
                    color: #9AA7C1;
                    font-size: 12px;
                }
            }
            .btn {
                hright: 20px;
                cursor: pointer;
                color: #789AFF;
            }
        }
    }
    .footer {
        text-align: center;
    }
}	
</style>


// WEBPACK FOOTER //
// src/components/basic/GameSharingDynamics.vue